let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("l3PYj")).then(() => parcelRequire('3FpGZ'));